module.exports = __webpack_public_path__ + "prod/20260227174758/img/service.edbff227.png";